(()=>{
  const init=root=>{
    if(root._leileArticles)return;
    root._leileArticles=true;
    const articles=[...root.querySelectorAll('[data-ar-article]')];
    const button=root.querySelector('[data-ar-toggle]');
    const label=root.querySelector('[data-ar-toggle-label]');
    const visible=Math.max(1,Number(root.dataset.mobileVisible)||2);
    const readMore=label?.textContent||'Read More';
    const showLess=root.dataset.expandedLabel||'Show Less';

    articles.forEach((article,index)=>{
      article.classList.toggle('is-mobile-teaser',index===visible);
      article.classList.toggle('is-mobile-hidden',index>visible);
    });

    button?.addEventListener('click',()=>{
      const expanded=root.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded',String(expanded));
      if(label)label.textContent=expanded?showLess:readMore;
      if(!expanded)root.scrollIntoView({behavior:'smooth',block:'start'});
    });

    new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(entry.isIntersecting)root.classList.add('is-visible');
    }),{threshold:.1}).observe(root);
  };
  const boot=scope=>scope.querySelectorAll?.('[data-leile-articles]').forEach(init);
  document.addEventListener('DOMContentLoaded',()=>boot(document));
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();
